import { PartnerListTop } from "@/features/rso/components/List";
import { PartnerTable } from "@/features/rso/components/PartnerTable";
import { Stack } from "@mui/material";
import { FC } from "react";
import { ERSOContractStatus } from "@/types/enum";

type TTrialPartnerListPageProps = {};

const contractStatuses = [ERSOContractStatus.TRIAL];

export const TrialPartnerListPage: FC<TTrialPartnerListPageProps> = () => {
  return (
    <Stack gap={2}>
      <PartnerListTop contractStatuses={contractStatuses} />
      <PartnerTable contractStatuses={contractStatuses} />
    </Stack>
  );
};
